export const GET_UPDATE_APPROVAL_DATA_START = "GET_UPDATE_APPROVAL_DATA_START";
export const GET_UPDATE_APPROVAL_DATA_SUCCESS = "GET_UPDATE_APPROVAL_DATA_SUCCESS"
export const GET_UPDATE_APPROVAL_DATA_ERROR = "GET_UPDATE_APPROVAL_DATA_ERROR"